export function writeClipboard({ html, text }) {
  if (html && navigator.clipboard?.write && window.ClipboardItem) {
    return navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" }),
        "text/plain": new Blob([text], { type: "text/plain" })
      })
    ]).catch(() => writeText(text))
  }

  return writeText(text)
}

export function writeText(text) {
  if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(text)

  return new Promise((resolve, reject) => {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.top = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      document.execCommand("copy") ? resolve() : reject(new Error("Copy command failed"))
    } catch (error) {
      reject(error)
    } finally {
      textarea.remove()
    }
  })
}
